import { Routes, Route, Navigate } from 'react-router-dom';
import { SiteContentProvider } from './context/SiteContentContext';
import { ProductsProvider } from './context/ProductsContext';
import { CartProvider } from './context/CartContext';
import ScrollToTop from './components/ui/ScrollToTop';
import Layout from './components/layout/Layout';
import AdminBar from './components/layout/AdminBar';
import HomePage from './pages/HomePage';
import ProductPage from './pages/ProductPage';
import AboutPage from './pages/AboutPage';
import CareGuidePage from './pages/CareGuidePage';
import ContactPage from './pages/ContactPage';
import PoliciesPage from './pages/PoliciesPage';
// SignInPage and AccountPage stay in src/pages for the later customer-accounts plan.
import CheckoutPage from './pages/CheckoutPage';
import CheckoutSuccessPage from './pages/CheckoutSuccessPage';
import NotFoundPage from './pages/NotFoundPage';
import CollectionPage from './pages/CollectionPage';
import RestoreBagPage from './pages/RestoreBagPage';
import UnsubscribePage from './pages/UnsubscribePage';
import AdminLayout from './admin/AdminLayout';
import AdminResetPassword from './admin/AdminResetPassword';

export default function App() {
  return (
    <SiteContentProvider>
      <ProductsProvider>
        <CartProvider>
          <ScrollToTop />
          {/* Admin-only strip above the navbar; hides itself on /admin and /checkout pages. */}
          <AdminBar />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/shop" element={<HomePage />} />
              <Route path="/shop/:slug" element={<CollectionPage />} />
            <Route path="/product/:slug" element={<ProductPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/care-guide" element={<CareGuidePage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/policies" element={<PoliciesPage />} />
              {/* Links from reminder emails (step 17). */}
              <Route path="/bag/restore/:token" element={<RestoreBagPage />} />
              <Route path="/unsubscribe/:token" element={<UnsubscribePage />} />
              {/* Hidden for launch: send these to the home page. */}
              <Route path="/signin" element={<Navigate to="/" replace />} />
              <Route path="/account/*" element={<Navigate to="/" replace />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
            <Route path="/admin" element={<AdminLayout />} />
            <Route path="/admin/reset" element={<AdminResetPassword />} />
          </Routes>
        </CartProvider>
      </ProductsProvider>
    </SiteContentProvider>
  );
}